import { render, staticRenderFns } from "./VSlidesCo.vue?vue&type=template&id=3b80e82a"
import script from "./VSlidesCo.vue?vue&type=script&lang=js"
export * from "./VSlidesCo.vue?vue&type=script&lang=js"
import style0 from "./VSlidesCo.vue?vue&type=style&index=0&id=3b80e82a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports